<div *ngIf="applicationStateManager.mailCenterIsDisplayed" class="mail-center-dialog">
    <div class="mail-center-header">
        <div class="mail-center-header-top-row">
            <div class="mail-center-header-hide-button" (click)="onHide()"><i class="fa fa-close"></i></div>
            <div class="mail-center-header-text">Notifications</div>
            <div class="mail-center-header-refresh-button" (click)="refresh()">
                <i class="fa fa-refresh" [ngClass]="{'fa-spin': mailCenterManager.isLoadingMessages}"></i>
            </div>
        </div>

        <div class="mail-center-header-bottom-row">
            <div class="mail-center-content-item-info-delete-all-button" (click)="deleteAllMessages()">Delete All</div>
            <div class="mail-center-content-item-info-mark-all-read-button" (click)="markAllMessagesAsRead()">Mark All Read</div>
        </div>
    </div>

    <div class="mail-center-content">
        <div *ngIf="messages.length !== 0">
            <div class="mail-center-content-item" *ngFor="let message of messages">
                <div class="mail-center-content-item-icon" [ngClass]="{'marked-read': message.IsRead}"><i class="fa fa-2x fa-check-circle"></i></div>
                <div class="mail-center-content-item-info-container">
                    <div class="mail-center-content-item-info-title" [ngClass]="{'marked-read': message.IsRead}">{{message.SubjectTitle}}</div>
                    <div class="mail-center-content-item-info-content">
                        <span class="mail-center-content-item-info-date">{{message.CreatedTimeUtc | date: 'MM/dd/yyyy hh:mm:ss a' }} - </span>
                        <span class="mail-center-content-item-info-text" [innerHtml]="message.DisplayableMessage"></span>
                    </div>
                    <div class="mail-center-content-item-info-buttons">
                        <div class="mail-center-content-item-info-delete-button" (click)="deleteMessage(message.Id)">Delete</div>
                        <div *ngIf="!message.IsRead" class="mail-center-content-item-info-mark-read-button" (click)="markMessageAsRead(message.Id)">Mark Read
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!mailCenterManager.isMailCenterInitialized && !mailCenterManager.isLoadingMessages"
             class="mail-center-content-item mail-center-content-item-no-messages">
            Please select a location to get the messages for the account.
        </div>

        <div *ngIf="messages.length === 0 && mailCenterManager.isMailCenterInitialized && !mailCenterManager.isLoadingMessages"
             class="mail-center-content-item mail-center-content-item-no-messages">
            You have no messages :)
        </div>
    </div>

</div>

<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading></app-loading>
</div>
